import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
export var apiComponentsMap = {
  left: ['tab'],
  right: ['tab'],
  ascending: ['table'],
  descending: ['table'],
  custom: ['table'],
  of: ['pagination'],
  previous: ['date picker', 'pagination'],
  next: ['date picker', 'pagination'],
  previousMonth: ['date picker'],
  nextMonth: ['date picker'],
  previousYear: ['date picker'],
  nextYear: ['date picker'],
  dayNames: ['date picker'],
  dayNamesMin: ['date picker'],
  monthNames: ['date picker'],
  selectYear: ['date picker'],
  chooseDate: ['date picker'],
  dateRange: ['date picker'],
  firstDayOfWeek: ['date picker'],
  datepickerRangeErrorMessage: ['date picker'],
  datepickerSingleErrorMessage: ['date picker'],
  timepickerTitle: ['date picker'],
  timepickerHourTitle: ['date picker'],
  timepickerMinuteTitle: ['date picker'],
  am: ['date picker'],
  pm: ['date picker'],
  clear: ['dropdown', 'input field', 'search', 'tag'],
  close: ['feed and comment', 'drawer', 'upload form', 'modal', 'notice'],
  selectionMessage: ['dropdown'],
  allSelectedMessage: ['dropdown'],
  selectAll: ['dropdown'],
  resultMessage: ['dropdown'],
  noResultMessage: ['dropdown', 'search'],
  noHistoryMessage: ['search'],
  comboboxPlaceholder: ['dropdown'],
  dropdownPlaceholder: ['dropdown'],
  likes: ['feed and comment'],
  comments: ['feed and comment'],
  more: ['feed and comment'],
  commentTitle: ['feed and comment'],
  writeComment: ['feed and comment'],
  yourComment: ['feed and comment'],
  addComment: ['feed and comment'],
  attachment: ['feed and comment'],
  deleteImage: ['feed and comment'],
  image: ['feed and comment'],
  none: ['rating and review'],
  ratingSliderLabel: ['rating and review'],
  ratingSentiments: ['rating and review'],
  "default": ['notice'],
  success: ['notice'],
  error: ['notice'],
  warning: ['notice', 'progress'],
  current: ['progress'],
  completed: ['progress'],
  upcoming: ['progress'],
  collapse: ['sidebar'],
  search: ['search'],
  uploadButtonLabel: ['upload form'],
  uploadErrorMessage: ['upload form'],
  uploadFileSizeErrorMessage: ['upload form'],
  uploadFileTypeErrorMessage: ['upload form'],
  fileSizeTypes: ['upload form'],
  dragAndDrop: ['upload form'],
  chooseFile: ['upload form'],
  deleteAttachments: ['upload form'],
  deleteFile: ['upload form'],
  reupload: ['upload form'],
  aria: {
    toggleButtonLabel: ['accordion', 'dropdown', 'sidebar'],
    breadcrumbLabel: ['breadcrumb'],
    buttonAddLabel: ['button'],
    datepickerLabel: ['date picker'],
    fileTreeLabel: ['file explorer'],
    pwcLogoLabel: ['header', 'sidebar'],
    notificationLabel: ['notice'],
    dateLabel: ['date picker'],
    monthLabel: ['date picker'],
    datepickerDisabledDateMessage: ['date picker'],
    datepickerInvalidDateMessage: ['date picker'],
    datepickerInvalidFormatMessage: ['date picker'],
    resultMessage: ['dropdown'],
    plusNumber: ['input field'],
    minusNumber: ['input field'],
    revealPassword: ['input field'],
    unrevealPassword: ['input field'],
    fieldDropdownButtonLabel: ['input field'],
    progressStepperLabel: ['progress'],
    stepDefaultLabel: ['progress'],
    ratingScaleLabel: ['rating and review'],
    ratingStarSelectionMessage: ['rating and review'],
    selected: ['rating and review', 'tab'],
    sidebarFooterLabel: ['sidebar'],
    sliderLeftHandleLabel: ['slider'],
    sliderRightHandleLabel: ['slider'],
    sliderRangeLabel: ['slider'],
    tablistLabel: ['tab'],
    tabsToggleButtonLabel: ['tab'],
    clickToScrollLabel: ['tab'],
    tableSortMessage: ['table'],
    tableUnsortMessage: ['table'],
    tooltipLabel: ['tooltip'],
    uploadFile: ['upload form'],
    uploadReadyMessage: ['upload form'],
    uploadSuccessMessage: ['upload form'],
    uploadErrorMessage: ['upload form'],
    uploadWithTriggerSuccessMessage: ['upload form'],
    uploadWithTriggerErrorMessage: ['upload form']
  }
};
export var initialState = {
  left: 'left',
  right: 'right',
  ascending: 'ascending',
  descending: 'descending',
  custom: 'custom',
  of: 'of',
  previous: 'Previous',
  next: 'Next',
  previousMonth: 'Previous month',
  nextMonth: 'Next month',
  previousYear: 'Previous year',
  nextYear: 'Next year',
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  selectYear: 'Select a year',
  chooseDate: 'Choose date',
  dateRange: 'Date range',
  firstDayOfWeek: 0,
  datepickerRangeErrorMessage: 'Please enter a valid date range',
  datepickerSingleErrorMessage: 'Please enter a valid date',
  timepickerTitle: 'Time',
  timepickerHourTitle: 'Hours',
  timepickerMinuteTitle: 'Minutes',
  am: 'AM',
  pm: 'PM',
  clear: 'Clear',
  close: 'Close',
  selectionMessage: '{0} item(s) selected',
  allSelectedMessage: 'All Selected',
  selectAll: 'Select All',
  resultMessage: '{0} item(s) available',
  noResultMessage: 'Nothing matches your keywords',
  noHistoryMessage: 'No recent searches',
  comboboxPlaceholder: 'Combobox',
  dropdownPlaceholder: 'Dropdown',
  likes: '{0} likes',
  comments: '{0} comments',
  more: 'More',
  commentTitle: 'Add a new comment',
  writeComment: 'Write a comment...',
  yourComment: 'Your comment',
  addComment: 'Add comment',
  attachment: 'Attachment',
  deleteImage: 'Delete image {0}',
  image: 'Image {0}',
  none: 'None',
  ratingSliderLabel: 'Rate your experience',
  ratingSentiments: ['Awful', 'Bad', 'Okay', 'Good', 'Great'],
  "default": 'default',
  success: 'success',
  error: 'error',
  warning: 'warning',
  current: 'current',
  completed: 'completed',
  upcoming: 'upcoming',
  collapse: 'Collapse',
  search: 'Search',
  uploadTitle: 'Upload your file(s)',
  uploadButtonLabel: 'Upload',
  uploadErrorMessage: 'We have encountered unexpected problems. The selected file won’t be uploaded.',
  uploadFileSizeErrorMessage: 'File size exceeds the maximum file size!',
  uploadFileTypeErrorMessage: 'File type is not allowed!',
  uploadFileNumberErrorMessage: 'The number of file items exceeds the limit!',
  fileSizeTypes: ['KB', 'MB'],
  dragAndDrop: 'Drag and drop or ',
  chooseFile: 'choose file(s)',
  deleteAttachments: 'Delete attachment(s)',
  deleteFile: 'Delete {file}',
  reupload: 'Reupload {file}',
  aria: {
    toggleButtonLabel: 'Toggle button',
    breadcrumbLabel: 'Breadcrumbs',
    buttonAddLabel: 'Add',
    datepickerLabel: 'Calendar',
    fileTreeLabel: 'File tree',
    pwcLogoLabel: 'PwC logo',
    notificationLabel: '{status} notification: {message}',
    dateLabel: '{dayName}, {monthName} {date}, {year}',
    monthLabel: '{monthName} {year}',
    datepickerDisabledDateMessage: '1 or more disabled day is selected in range',
    datepickerInvalidDateMessage: 'Invalid date, review dates entered',
    datepickerInvalidFormatMessage: 'Invalid date format, enter date in {format} format',
    resultMessage: 'There are {0} item(s) available.',
    plusNumber: 'Plus Number',
    minusNumber: 'Minus Number',
    revealPassword: 'Reveal password',
    unrevealPassword: 'Unreveal password',
    fieldDropdownButtonLabel: '{title} type dropdown',
    progressBarLabel: 'Progress bar',
    progressStepperLabel: 'Progress stepper',
    stepDefaultLabel: 'step {0}',
    ratingScaleLabel: 'Rating scale {0} out of {1} star(s)',
    ratingStarSelectionMessage: '{0} out of {1} star(s) selected',
    selected: '{item} selected',
    sidebarFooterLabel: 'Navigation operation',
    sliderLeftHandleLabel: 'Left handle of slider {id}.',
    sliderRightHandleLabel: 'Right handle of slider {id}.',
    sliderRangeLabel: 'The minimum value is {min}, the maximum value is {max}.',
    tablistLabel: 'Tablist',
    tabsToggleButtonLabel: 'Show overflow tabs',
    clickToScrollLabel: 'Click to scroll {direction}',
    tableSortMessage: 'Click to sort rows by {sortKey} in {order} order',
    tableUnsortMessage: 'Click to unsort rows by {sortKey}',
    tooltipLabel: 'Tooltip {content}',
    uploadFile: 'Upload file(s)',
    uploadReadyMessage: 'Ready to upload.',
    uploadSuccessMessage: 'Upload successfully.',
    uploadErrorMessage: 'We have encountered unexpected problems. The selected file won’t be uploaded.',
    uploadWithTriggerSuccessMessage: 'Upload(s) complete.',
    uploadWithTriggerErrorMessage: 'Upload error, review items.'
  }
};
var setHtmlLang = function setHtmlLang(lang) {
  document.documentElement.lang = lang;
};
var LocalizationContext = /*#__PURE__*/React.createContext({
  t: function t(key) {
    return initialState[key];
  },
  update: function update(data) {},
  setHtmlLang: setHtmlLang
});
var translationReducer = function translationReducer(state, action) {
  switch (action.type) {
    case 'UPDATE':
      return _extends({}, state, action.data);
    default:
      return state;
  }
};
export var LocalizationProvider = function LocalizationProvider(props) {
  var _React$useReducer = React.useReducer(translationReducer, initialState),
    state = _React$useReducer[0],
    dispatch = _React$useReducer[1];
  var value = {
    t: function t(key) {
      return state[key];
    },
    update: function update(data) {
      return dispatch({
        type: 'UPDATE',
        data: data
      });
    },
    setHtmlLang: setHtmlLang
  };
  return /*#__PURE__*/React.createElement(LocalizationContext.Provider, {
    value: value
  }, props.children);
};
export var useLocalization = function useLocalization() {
  var context = React.useContext(LocalizationContext);
  if (typeof context === 'undefined') {
    throw new Error('useLocalization must be used within a LocalizationProvider');
  }
  return context;
};